// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInAnonymously, sendSignInLinkToEmail, setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_AUTH_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_AUTH_PROJECT_ID,
  storageBucket: import.meta.env.VITE_AUTH_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_AUTH_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_AUTH_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Google provider
export const googleProvider = new GoogleAuthProvider();

// Sign in with Google
export const signInWithGoogle = async (): Promise<void> => {
  try {
    await signInWithPopup(auth, googleProvider);
  } catch (error: unknown) {
    if (error instanceof Error) throw new Error(`Google sign-in failed: ${error.message}`);
    throw new Error("Google sign-in failed: Unknown error");
  }
};

// Sign in anonymously
export const signInAnonymouslyUser = async (): Promise<void> => {
  try {
    await setPersistence(auth, browserLocalPersistence);
    await signInAnonymously(auth);
  } catch (error: unknown) {
    if (error instanceof Error) throw new Error(`Anonymous sign-in failed: ${error.message}`);
    throw new Error("Anonymous sign-in failed: Unknown error");
  }
};

// Send sign-in link via email
export const sendEmailLink = async (email: string): Promise<void> => {
  const actionCodeSettings = {
    url: window.location.origin + "/auth/finish",
    handleCodeInApp: true,
  };

  try {
    await sendSignInLinkToEmail(auth, email, actionCodeSettings);
    window.localStorage.setItem("emailForSignIn", email); // store for later
  } catch (error: unknown) {
    if (error instanceof Error) throw new Error(`Failed to send sign-in link: ${error.message}`);
    throw new Error("Failed to send sign-in link: Unknown error");
  }
};



export default app;
